let lastDpr = window.devicePixelRatio;
let listening = false;

const resizeListeners: Set<() => void> = new Set();
const scaleListeners: Set<() => void> = new Set();

const setupListener = () => {
    if (listening) {
        return;
    }

    window.addEventListener("resize", () => {
        if (lastDpr !== window.devicePixelRatio) {
            lastDpr = window.devicePixelRatio;
            window.requestAnimationFrame(() => {
                scaleListeners.forEach((cb) => cb());
            });
        } else {
            resizeListeners.forEach((cb) => cb());
        }
    });

    listening = true;
};

export const onResize = (cb: () => void, scale = true) => {
    setupListener();
    resizeListeners.add(cb);

    if (scale) {
        scaleListeners.add(cb);
    }

    return () => {
        resizeListeners.delete(cb);

        if (scale) {
            scaleListeners.delete(cb);
        }
    };
};

export const onScale = (cb: () => void) => {
    setupListener();
    scaleListeners.add(cb);

    return () => {
        scaleListeners.delete(cb);
    };
};
